<template>
  <div class="header" v-bind:style="styling">
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'sectionHeader',
  props: {
    text: {
      type: String,
      default: ''
    },
    styling: {
      type: Object,
      default: function () {
        return { fontSize: '36px' }
      }
    }
  }
}
</script>

<style scoped>

.header {
  text-align: center;
  font-weight:bold;
  padding-top: 25px;
  text-transform: uppercase;
  word-wrap: break-word;
}

</style>



// WEBPACK FOOTER //
// src/components/text/SectionHeader.vue